import { Component, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';

import { setPreferenceIndicesCalcs } from 'IndicesApp/ts/apps/index-family-app/state/family-indices-table/family-indices-table.action';

import { IndexFamilyRootStore } from 'IndicesApp/ts/apps/index-family-app/state/interfaces/index-family-root-store.interface';

import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { CalculationsService } from 'CalculationsApp/ts/services/calculations.service';

import { EditDataColumnsModalComponent } from 'Angular/features/components/modals/edit-data-columns-modal/edit-data-columns-modal.component';
import { IndicesEditColumnsModalDirective } from 'IndicesApp/ts/shared/features/base-indices-edit-modals/directives/indices-edit-columns-modal.directive';

@Component({
    standalone: false,
    selector: 'ycn-index-family-edit-columns-modal',
    templateUrl: './index-family-edit-columns-modal.template.html',
})
export class IndexFamilyEditColumnsModalComponent extends IndicesEditColumnsModalDirective {
    @ViewChild(EditDataColumnsModalComponent) editDataColumnsModalComponent!: EditDataColumnsModalComponent;

    constructor(
        accountsService: AccountsService,
        calculationsService: CalculationsService,
        private readonly store: Store<{ reducers: IndexFamilyRootStore }>
    ) {
        super(accountsService, calculationsService);
        this.preferenceName = 'indices_page_family_indices_columns';
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }

    updateState(calcNames: string[]): void {
        this.store.dispatch(setPreferenceIndicesCalcs({ calcs: calcNames }));
    }
}
